<template>
  <v-container class="pt-10">

    <!-- transition for opening item -->
    <LoadingCover v-if="isOpening"
                  :item="isOpening"/>

    <!-- default layout -->
    <div v-else>

      <p class="text-h4 font-weight-bold mb-5">
        Ultime uscite
      </p>

      <Library :items="libraries"
               @click="goToLibrary"
               :loading="isLoading"/>

      <Categories class="my-10"/>

      <Collection v-for="collection in collections"
                  :key="collection.id"
                  :collection="collection"
                  :loading="isLoading"
                  @click="goToLibrary"
                  class="my-10"/>
      
    </div>

  </v-container>
</template>

<script>
import axios from 'axios'
import API from '@/api'

import { mapMutations } from 'vuex'

import utility from '@/mixins/utility'

import Categories from '@/components/Categories/Categories'
import Collection from '@/components/Collections/Collection'
import Library from '@/components/Grids/Simple'
import LoadingCover from '@/components/UI/LoadingCover'

export default {
  
  name: 'Home',

  mixins: [ utility ],

  components:
  {
    Categories,
    Collection,
    Library,
    LoadingCover
  },

  data: () => ({
    collections: [],
    isLoading: false,
    isOpening: null,
    libraries: []
  }),

  computed:
  {
    
  },

  methods: 
  {
    ...mapMutations({
      setLoading: 'ui/setLoading'
    }),

    load()
    {
      this.isLoading = true

      axios.all([
          this.loadLibraries(),
          this.loadCollections()
        ])
        .then(axios.spread((/*...responses*/) => {

        }))
        .catch(errors => {
          console.error(errors)
        })
        .finally(()=>this.isLoading=false)
    },

    loadLibraries()
    {
      return API.library.list()
                        .then(({ data })=>{

                          this.libraries = this.mapModels(data.data, 'library')

                        })
    },

    loadCollections()
    {
      return API.collection.list({ include:'libraries' })
                        .then(({ data })=>{

                          this.collections = this.mapModels(data.data, 'collection')

                        })
    },

    goToLibrary(library)
    {
      this.isOpening = library

      let params = {
                      slug: library.slug,
                      library
                    }
      
      this.goTo({ name:'library', params })
    }
  },

  mounted()
  {
    this.load()

    this.hideBack()
  },

  watch:
  {
    isLoading()
    {
      //this.setLoading(value)
    }
  }

}
</script>
